import { Stack } from "@mui/material";
import type { ReportAccessType } from "@entrilia/shared/api/reportAccessTypes.ts";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import AccessModeMenuLabel from "../AccessModeMenuLabel.tsx";
import AuthorizationUserItem from "../AuthorizationUserItem.tsx";
import type { UserItem } from "./authorizedItems.ts";

interface AuthorizedUsersListProps {
  items: UserItem[];
  disabled: boolean;
  onAccessChanged: (userId: string, access: ReportAccessType) => void;
  onRemoveUser: (userId: string) => void;
}

export default function AuthorizedUsersList({
  items,
  disabled,
  onAccessChanged,
  onRemoveUser,
}: AuthorizedUsersListProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Stack spacing={2} sx={{ overflow: "auto" }}>
      {items.map((user) => {
        return (
          <Stack key={user.userId} direction={"row"} spacing={1.5} sx={{ alignItems: "center" }}>
            <AuthorizationUserItem
              name={user.name}
              email={user.email}
              isCurrentUser={user.isCurrentUser}
              iconSize="medium"
            />
            <HorizontalFill />
            <AccessModeMenuLabel
              access={user.access}
              allowedAccesses={user.allowedAccesses}
              hasRemove
              disabled={disabled}
              onSelect={(access) => onAccessChanged(user.userId, access)}
              onRemove={() => onRemoveUser(user.userId)}
            />
          </Stack>
        );
      })}
    </Stack>
  );
}
